import { PropsWithChildren } from 'react';
import classes from './ActionButton.module.scss';

const ActionButton = ({ children }: PropsWithChildren): JSX.Element => {
  return <div className={classes['service-btn']}>{children}</div>;
};

export default ActionButton;
